import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import store from '@core/app/store/store'
import { RecaptchaProvider } from '@core/utils/contexts/RecaptchaProvider/RecaptchaProvider'

import '../../index.css'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import ErrorBoundary from '@core/utils/helpers/errorBoundary'
import { initSentry } from '@core/utils/sentry/initSentry'

import theme from '../../theme.js'

import { ForgotPage } from './ForgotPage'

import '@core/utils/i18n'
import * as Sentry from '@sentry/react'

initSentry()

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : '/forgot-password',
        element: (
            <ErrorBoundary fallback={<div>Something went wrong...</div>}>
                <ThemeProvider>
                    <RecaptchaProvider>
                        <ForgotPage />
                    </RecaptchaProvider>
                </ThemeProvider>
            </ErrorBoundary>
        ),
    },
])

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <RouterProvider router={router} />
            </ChakraProvider>
        </Provider>
    </>
)
